import React, { useState } from 'react';
import Spiner from '../../components/Spiner';
import accessLogic from '../../functions/logic/Access';
import { useSnackbar } from 'notistack';

export default function ForgotPassword() {
    const [spiner, setSpiner] = useState(false)
    const [email, setEmail] = useState('')
    const { enqueueSnackbar } = useSnackbar();
    const keyEnter = (event) => {
        if (event.keyCode === 13) {
            handleRestore()
        }
    }
    const handleRestore = async (event) => {
        setSpiner(true);
        if (email !== "") {
            const link = window.location.origin + '' + global.RESETPASSWORDLINK;
            const resp = await accessLogic.setPaswordLinkLogic(email, link);
            enqueueSnackbar(resp.message, {
                variant: resp.variant,
                anchorOrigin: {
                    vertical: 'top',
                    horizontal: 'right'
                }
            })
            setEmail('');
        } else {
            enqueueSnackbar('Ingrese su email', {
                variant: 'warning',
                anchorOrigin: {
                    vertical: 'top',
                    horizontal: 'right'
                }
            })
        }
        setSpiner(false);
    }
    return (
        <>
            <Spiner opt={spiner} />
            <div className="hold-transition login-page">
                <div className="login-box">
                    <div className="login-logo">
                        <b>Recuperar contraseña</b>
                    </div>
                    <div className="card">
                        <div className="card-body login-card-body">
                            <div className="login-box-msg">Se enviará un link a su correo registrado para poder cambiar la contraseña</div>
                            <div className="input-group mb-3">
                                <input maxLength="30" value={email} minLength="1" onKeyDown={(e) => keyEnter(e)} onChange={({ target }) => setEmail(target.value)} type="email" className="form-control" placeholder={global.LOGIN_EMAIL_TXT} />
                                <div className="input-group-append">
                                    <div className="input-group-text">
                                        <span className={global.LOGIN_FA_EMAIL} ></span>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-12">
                                    <button onClick={handleRestore} className="btn btn-primary btn-block">Enviar correo de recuperación</button>
                                </div>
                            </div>
                            <div className="social-auth-links text-center mb-3">
                            </div>
                            <div className="mb-1">
                                <a href={window.location.origin}>Regresar al login</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}